module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#health",
      toString: function () {
        return this.url;
      }
    }